import React, { useState } from "react";
import { TableSortLabel } from "@mui/material";
import "./styles/RolesTableHeader.css";
import {
  TableRow,
  TableHead
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f9ccb5",
    color: theme.palette.common.black,
    fontWeight: 600,
    fontSize: 12,
    borderRight: "1px solid #80808040",
    borderBottom: "0px",
    padding: 3
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    color: "black",
    fontWeight: 400,
    borderRight: "1px solid #80808040",
    borderBottom: "0px",
    padding: 3
  }
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "rgb(0 255 205 / 4%)"
  }
}));

const RolesTableHeader = ({ columns, sortHandler }) => {
  const [rolesTableColumns] = useState(columns);
  const [sortField, setSortField] = useState("");
  const [sortBy, setSortBy] = useState("asc");

  const sortChangeHandler = (accessor) => {
    const sortOrder =
      accessor === sortField && sortBy === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setSortBy(sortOrder);
    sortHandler(accessor, sortOrder);
  };

  return (
      <TableHead>
      <StyledTableRow>
        {rolesTableColumns.map((column) => {
          return (
            <StyledTableCell
            key={column.accessor}
              className="roles_tableHeadRow"
              onClick={
                column.sortable
                  ? () => sortChangeHandler(column.accessor)
                  : null
              }
          >
            <TableSortLabel
              active={sortField === column.accessor}
                hideSortIcon={!column.sortable}
                direction={
                  column.sortable ?
                    sortField === column.accessor && sortBy === "asc"
                      ? "asc"
                      : sortField === column.accessor && sortBy === "desc"
                        ? "desc"
                        : undefined
                    : undefined
                }
            >
              {column.name}
            </TableSortLabel>
          </StyledTableCell>
          );
        })}
        </StyledTableRow>
    </TableHead>
  );
};

export default RolesTableHeader;

